import { render, staticRenderFns } from "./CreationModal.vue?vue&type=template&id=4fad8a0c&"
import script from "./CreationModal.vue?vue&type=script&lang=js&"
export * from "./CreationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports